module.exports = __webpack_public_path__ + "static/media/str-chat__reaction-list-sprite@2x.bccb11b9.png";